export default {
  noData: "Không có bản ghi nào",
  search: "Tìm kiếm...",
  allSearch: "Tất cả",
  other: "Khác",
  active: "Đang theo dõi",
  inactive: "Ngừng theo dõi",
  FeaturesIsDeveloping: "Tính năng đang phát triển",
  tree: "Dạng cây",
  list: "Dạng danh sách",
  notification: "Thông báo",
  summaryTotal: "Tổng số lượng",
  wait: "Vui lòng chờ",
  member: "Thành viên",
  financialReport: "Báo cáo tài chính",
  notActive: "chưa hoạt động",
  addInfo: "Thông tin bổ sung",
  command: {
    download: "Tải xuống",
    copy: "Sao chép",
    add: "Thêm",
    edit: "Sửa",
    delete: "Xóa",
    duplicate: "Nhân bản",
    more: "Thêm nữa...",
    save: "Lưu",
    saveNew: "Lưu & Thêm",
    saveSend: "Lưu & gửi",
    send: "Gửi",
    close: "Đóng",
    no: "Không",
    hide: "Ẩn",
    help: "Giúp",
    cancel: "Hủy",
    accept: "Đồng ý",
    attack: "Đính kèm",
    saveAndNew: "Lưu và thêm mới",
    confirm: "Xác nhận",
    notConfirm: "Không xác nhận",
    export: "Xuất khẩu",
    load: "Nạp",
    print: "In",
    filter: "Lọc",
    refresh: "Nạp",
    setting: "Thiết lập",
    default: "Mặc định",
    list: "Danh sách",
    requestRefund: "Yêu cầu hoàn tiền",
    kaban: "Kaban",
    addDetail: "Thêm dòng",
    import: "Nhập khẩu",
    allocation: "Cấp phát",
    reduce: "Thu hồi",
    broken: "Đánh dấu hỏng",
    repair: "Sửa chữa",
    denyBroken: "Từ chối báo hỏng",
    denyLost: "Từ chối báo mất",
    maintain: "Bảo dưỡng",
    schedule: "Lập lịch",
    scheduleRepair: "Lập lich sửa chữa",
    scheduleMaintain: "Lập lịch bảo dưỡng",
    reUse: "Đưa vào sử dụng lại",
    requestLiquidate: "Đề nghị thanh lý",
    liquidation: "Thanh lý",
    transfer: "Điều chuyển",
    Ultility: "Tiện ích",
    logout: "Đăng xuất",
    changeLocal: "Thay đổi vị trí",
    changeManagement: "Thay đổi người quản lý",
    changeStatus: "Thay đổi trạng thái",
    createDocument: "Tạo văn bản",
    cancelAsset: "Hủy tài sản",
    next: "Tiếp theo",
    Cancel: "Hủy",
    Back: "Quay lại trang chủ",
    PreviousPage: "Quay lại trang trước",
    permissions: "Phân quyền người dùng",
    View: "Xem chi tiết",
    connect: "Kết nối",
    OK: "OK",
    Register: "Đăng ký",
    ConfirmAgreement: "Tôi đã đọc và đồng ý với các điều khoản",
    change: "Chuyển",
    update: "Cập nhật",
    sync: "Đồng bộ",
    PrivacyPolicy: "Chính sách bảo vệ dữ liệu cá nhân",
  },
  module: {
    paymentlink: "Link thanh toán",
    asset: "Tài sản",
    assetType: "Loại tài sản",
    assetCategory: "Nhóm tài sản",
    location: "Vị trí địa lý",
    provider: "Nhà cung cấp",
    report: "Báo cáo",
    organizationUnit: "Cơ cấu tổ chức",
    organizationUnitType: "Cấp tổ chức",
    jobposition: "Vị trí công việc",
    jobtitle: "Chức danh",
    employee: "Nhân viên",
    role: "Vai trò",
    schedule: "Lịch bảo dưỡng sửa chữa",
    tally: "Biên bản kiểm đếm",
    user: "Người dùng",
    template: "Mẫu văn bản",
    accountObject: "Nhà cung cấp",
    usageHistory: "Lịch sử quá trình sử dụng",
    jobPosition: "Vị trí công việc",
    transfer: "Điều chuyển",
    audit: "Kiểm kê",
    allocationReduceLocation: "Vị trí tài sản",
    moduleprocess: "",
    moduleAccountObjectGroup: "Nhóm nhà cung cấp",
    usersystem: "Người dùng",
    revenuemanagement: "Yêu cầu thanh toán",
  },
  /**
   * Các resource chung của phần xuất khẩu: summary, stt, group...
   */
  exportCommon: {
    STT: "STT",
    RowCountGroup: "RowCountGroup",
    RowCount: "RowCount",
  },
  ReportTerm: "Kỳ báo cáo",
  FromDate: "Từ ngày",
  FromMonth: "Từ tháng",
  Time: "Thời gian",
  ToDate: "Đến ngày",
  ToMonth: "Đến tháng",
  NotSmallerThan: "phải lớn hơn hoặc bằng",
  Ams: "Thông báo",
  Filter: "Lọc",

  Button: {
    Add: "Thêm",
    Cancel: "Hủy",
  },
  Title: {
    AddMerchant: "Thêm đơn vị mới",
  },
  Label: {
    MerchantName: "Tên đơn vị",
    Add: "Thêm đơn vị mới",
  },
  Message: {
    Success: "Thành công",
    SendSuccess: "Gửi yêu cầu thanh toán thành công!",
    AddSuccess: "Thêm đơn vị thành công. Khai báo thông tin hồ sơ để định danh tài khoản.",
    AddPeriodSuccess: "Thêm mới đợt thu thành công!",
    ConfirmSwapMerchant: "Bạn có chắc chắn muốn chuyển qua đơn vị này không?",
    Error: "Có lỗi xảy ra. Vui lòng thử lại!",
    UpdateSuccess: "Cập nhật thành công!",
    DeleteSuccess: "Xoá thành công!",
    DuplicateSuccess: "Nhân bản đợt thu thành công!",
  },
  /**
   * AMIS Platform auth i18n keys
   * UpdatedBy: dbhuan (09/06/2026)
   */
  ampl: {
    sessionInvalid: "Phiên làm việc không hợp lệ, vui lòng đăng nhập lại",
    sessionMissing: "Thiếu thông tin phiên làm việc",
    sessionExpired: "Phiên làm việc đã hết hạn, vui lòng đăng nhập lại",
    loggingIn: "Đang đăng nhập...",
    loggingOut: "Đang đăng xuất...",
    logoutSuccess: "Đăng xuất thành công",
    logoutFailed: "Không thể hủy phiên làm việc",
    missingSessionInfo: "Thiếu thông tin phiên làm việc",
    connectionError: "Không thể kết nối đến máy chủ. Vui lòng thử lại.",
    redirectToLogin: "Đang chuyển hướng về trang đăng nhập...",
  },
  MessageYCTT: {
    AddSuccess: "Lưu yêu cầu thanh toán thành công!",
    AddAndSendSuccess: "Lưu và gửi yêu cầu thanh toán thành công!",
    SendSuccess: "Gửi yêu cầu thanh toán thành công!",
    UpdateSuccess: "Lưu thông tin thành công!",
    DeleteSuccess: "Xoá yêu cầu thanh toán thành công!",
    TransitionPeriodSuccess: "Chuyển đợt thu thành công!",
    ErorrAtLeast: "Vui lòng chọn ít nhất 1 yêu cầu thanh toán!",
    ErorrSendAtLeast: "Vui lòng chọn yêu cầu thanh toán muốn gửi cho khách hàng!",
    ErorrTransition: "Vui lòng chọn yêu cầu thanh toán muốn chuyển đợt thu!",
    ErrorSelected:
      'Vui lòng chọn yêu cầu thanh toán ở trạng thái "Chưa thông báo" và "Đã thông báo"!',
  },
};
